import { useVisibleContainer } from "../../hooks/useVisibleContainer";

// Route-effect component for "/couple-wheel". Renders nothing -
// CoupleWheelPage.tsx (mounted unconditionally in AppRoot) owns the actual
// rendering into #coupleWheelView, same pattern as ProfileRouteScreen.tsx.
export function CoupleWheelRouteScreen() {
  useVisibleContainer("coupleWheelView");
  return null;
}
